import "@/styles/store-storefront.css";
import { cn } from "@/lib/utils";

export function PublicStoreShell({
  branding = {},
  outerClassName = "",
  innerClassName = "bg-white",
  children,
}) {
  const style = {
    "--store-primary": branding.theme_primary ?? "#F36F21",
    "--store-secondary": branding.theme_secondary ?? "#2B0B04",
    "--store-accent": branding.theme_accent ?? "#FF8A3D",
    "--store-surface": branding.theme_surface ?? "#FDF8F5",
  };

  return (
    <div
      className={cn("store-storefront restaurant-store-mesh min-h-[100dvh] flex justify-center", outerClassName)}
      style={style}
    >
      <div
        className={cn(
          "relative w-full max-w-md min-h-[100dvh] border border-orange-900/10 shadow-[0_24px_64px_-20px_rgba(43,11,4,0.22)]",
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export function StoreLogo({ url, name, alt, className = "" }) {
  if (url) {
    return (
      <img
        src={url}
        alt={alt ?? `${name} logo`}
        className={cn("object-contain", className)}
        style={{ maxWidth: "9rem", maxHeight: "7rem", width: "auto" }}
      />
    );
  }

  const initials = String(name || "AM")
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <span className={cn("font-extrabold uppercase tracking-[0.2em] text-white", className)}>
      {initials}
    </span>
  );
}
